export default __webpack_public_path__ + "static/media/FLYNG.730844f4.png";